import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { MasterService } from 'src/app/services/master-mom.service';
import { ToastrUtilsService } from 'src/app/services/toastr-utils.service';
import { environment } from 'src/environments/environment';
import { RSAHelper } from '../services/RSAHelper';
import { UserService } from '../services/user.service'
@Component({
  selector: 'app-all-applications',
  templateUrl: './all-applications.component.html',
  styleUrls: ['./all-applications.component.scss'],
  providers: [ToastrUtilsService]
})
export class AllApplicationsComponent implements OnInit {
  applnList: any = []; sectionname: string = "";
  user: any = []; useremail: string = ""; userprofileInfo: any = [];

  constructor(public router: Router, private modalService: BsModalService,
    public RSAHelper: RSAHelper, private userService: UserService, public masterservice: MasterService, private spinner: NgxSpinnerService, private toastr: ToastrUtilsService) { }
  ngOnInit() {

    this.user = this.userService.getUserInfo();
    this.checkuserInfo();

    this.LoadApplication();
  }
  closeDialog() {
    this.modalService.hide(1);
  }

  LoadApplication() {

    const objTxnData = {
      "email": this.RSAHelper.encryptWithPublicKey(JSON.stringify( this.user.email)), 
      "isExternal": this.RSAHelper.encryptWithPublicKey(JSON.stringify( environment.isExternal)),   
    };
   
    this.masterservice.allApplns(JSON.stringify(objTxnData)).subscribe((result: any) => {
      this.applnList = result.data; 
      //setTimeout(() => { this.spinner.hide(); }, 1000);            
    },
      (error) => {
        //console.log(error);
        this.toastr.ErrorCustomMessage('There was an unexpected error.');
        this.spinner.hide();
      }
    ).add(() => {
      // Called when operation is complete (both success and error)
      // this.spinner.hide();
      this.spinner.hide();
    });
  }

  checkuserInfo() {
    try {
      //this.userprofileInfo = this.userService.getUserProfileInfo(this.useremail);
      this.userService.getUserProfileInfo(this.useremail).
        subscribe((result: any) => {
          var response;
          if (result.data == undefined) { response = result; this.userprofileInfo = response; }
          else { response = result.data; this.userprofileInfo = JSON.parse(this.userService.loadprofiledata(response)); }

        });
    }
    catch (e) { console.log(e); }
  }

  AddNewSection() {
    try {

      const selectedApps = this.applnList.filter(item => item.selected === true);
      if (selectedApps.length == 0) {
        //this.toastr.InfoMessage('Please select apps');
        return;
      }
      //console.log(selectedApps);
      var appID = '';
      for (var apps of selectedApps) {
        appID = appID + "," + apps.appid;
      }
      if (appID.substring(0, 1) === ",") {
        appID = appID.slice(1);
      }
 
      const objTxnData = {
        "sectionname": this.RSAHelper.encryptWithPublicKey(JSON.stringify( this.sectionname)),                           
        "employeeuno": this.RSAHelper.encryptWithPublicKey(JSON.stringify(this.userprofileInfo.employeeuno)), 
        "appid": this.RSAHelper.encryptWithPublicKey(JSON.stringify(appID)),
        "PRNumber": this.RSAHelper.encryptWithPublicKey(JSON.stringify(this.userprofileInfo.userPRnumber)),
        "email": this.RSAHelper.encryptWithPublicKey(JSON.stringify(this.user.email))
    }
     
    this.masterservice.AddNewSection(JSON.stringify(objTxnData))
        .subscribe((result: any) => {
          const response = result.data;
          if (response.dictionary.IntResult > 0) {
            this.toastr.SuccessCustomMessage('Section added successfully.');
            //redirect to myApps page
            this.router.navigate(['/home/AppCatalog']);
            //this.LoadApplication();
          } else {
            if (response.dictionary.stringResult.includes('Violation of UNIQUE KEY constraint')) {
              this.toastr.ErrorCustomMessage('Section Already exists');
            } else {
              this.toastr.ErrorCustomMessage('There was an unexpected error.');
            }
          }
        },
          (error) => {
            this.toastr.ErrorCustomMessage('There was an unexpected error.');
            this.spinner.hide();
          }
        ).add(() => {
          this.spinner.hide();
        });
    }
    catch (err) {
      this.toastr.ErrorCustomMessage('There was an unexpected error.');
      this.spinner.hide();
    }
  }
}